import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6e4817e6")

_pushScopeId("data-v-6e4817e6")
const _hoisted_1 = { class: "title" }
const _hoisted_2 = /*#__PURE__*/_createVNode("span", { class: "icon icon-g-video-set-music-off" }, null, -1)
const _hoisted_3 = { class: "switch" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", {
    class: ["switch-root", { 'mobile-d': _ctx.device.display === 1 }]
  }, [
    _createVNode("span", _hoisted_1, [
      _hoisted_2,
      _createTextVNode(_toDisplayString(_ctx.label), 1)
    ]),
    _createVNode("div", _hoisted_3, [
      _createVNode("label", null, [
        _withDirectives(_createVNode("input", {
          type: "checkbox",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.isCheck = $event)),
          onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.OnValueChange && _ctx.OnValueChange(...args)))
        }, null, 544), [
          [_vModelCheckbox, _ctx.isCheck]
        ])
      ])
    ])
  ], 2))
})